/**
 * Canonical /logs search baseline — keep in sync with
 * erp_api/routes/controllers/activityLogsSearchBaseline.ts
 *
 * FE builds POST /searchlogs bodies from here; GPT log fill uses the API copy.
 */

import { ACTIVITY_LOGS_PER_PAGE } from './activityLogsTableAmount';
import { DEFAULT_LOG_SEARCH_OPTIONS } from './redux';
import type { ActivityLogsSearchCriteriaSource, ActivityLogsSearchPayload } from './activityLogsSearchPayload';
import { SHOW_ALL_ACTIVITY_LOGS } from './activityGroupsModel';

/** /logs default: Show all scopes, cash in+out, no Time toggle — same pool GPT searches. */
export const buildDefaultActivityLogsSearchCriteria = (
  overrides: Partial<ActivityLogsSearchCriteriaSource> = {},
): ActivityLogsSearchCriteriaSource => ({
  logSearches: [],
  logSearch: '',
  logSearchOptions: { ...DEFAULT_LOG_SEARCH_OPTIONS },
  checked: [SHOW_ALL_ACTIVITY_LOGS],
  valueMode: 'value',
  allItems: true,
  cashIn: true,
  cashOut: true,
  useTimeRange: false,
  startDate: null,
  endDate: null,
  onlyLogIds: null,
  startLogId: null,
  endLogId: null,
  viewAs: null,
  associateElevatedActivityLogs: false,
  isComplianceActivity: false,
  complianceActivityStaffId: null,
  ...overrides,
});

export const clientActivityLogsTimeContext = (): {
  clientTodayYmd: string,
  timezoneOffsetMinutes: number,
} => {
  const now = new Date();
  const clientTodayYmd = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('-');
  return {
    clientTodayYmd,
    timezoneOffsetMinutes: now.getTimezoneOffset(),
  };
};

export const ACTIVITY_LOGS_SEARCH_BASELINE_PAGE_SIZE = ACTIVITY_LOGS_PER_PAGE;

export type { ActivityLogsSearchPayload };
